function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "480px",
    height: "480px",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.117647%,85.098039%,12.156863%)",
      fillOpacity: 1
    },
    d: "M 15 15 L 465 15 L 465 465 L 15 465 Z M 15 15 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 465 480 L 15 480 C 6.71875 480 0 473.28125 0 465 L 0 15 C 0 6.71875 6.71875 0 15 0 L 465 0 C 473.28125 0 480 6.71875 480 15 L 480 465 C 480 473.28125 473.28125 480 465 480 Z M 30 450 L 450 450 L 450 30 L 30 30 Z M 30 450 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 190 440 C 159.238281 440 132.480469 418.160156 126.320312 388.078125 C 125.441406 383.78125 125 379.398438 125 375 C 125 366.71875 131.71875 360 140 360 C 148.28125 360 155 366.71875 155 375 C 155 377.378906 155.238281 379.761719 155.71875 382.078125 C 159.019531 398.261719 173.441406 410 190 410 C 209.300781 410 225 394.300781 225 375 L 225 235 C 225 226.71875 231.71875 220 240 220 C 248.28125 220 255 226.71875 255 235 L 255 375 C 255 410.839844 225.839844 440 190 440 Z M 365 440 C 326.398438 440 295 413.078125 295 380 C 295 371.71875 301.71875 365 310 365 C 318.28125 365 325 371.71875 325 380 C 325 396.261719 343.320312 410 365 410 C 386.679688 410 405 396.261719 405 380 C 405 365.28125 390.078125 353.28125 360.640625 344.359375 C 318.320312 331.5 295 308.660156 295 280 C 295 246.921875 326.398438 220 365 220 C 403.601562 220 435 246.921875 435 280 C 435 288.28125 428.28125 295 420 295 C 411.71875 295 405 288.28125 405 280 C 405 263.738281 386.679688 250 365 250 C 343.320312 250 325 263.738281 325 280 C 325 299.300781 352.800781 310.621094 369.359375 315.640625 C 423.621094 332.101562 435 359.71875 435 380 C 435 413.078125 403.601562 440 365 440 Z M 365 440 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.0cd52f1b878f6799601a2a05069d997d.svg";
export { ForwardRef as ReactComponent };